/**
 * Definições de TODA coluna built-in da tabela /operacoes.
 *
 * Cada coluna obrigatoriamente tem:
 *   - `label`: nome curto pro header (UPPERCASE no render).
 *   - `name`: nome longo pra pickers/export.
 *   - `w`: largura inicial em px ou fr.
 *   - `align`: 'left' | 'right' | 'center'.
 *   - `mono`: true pra fonte monoespaçada (números/IDs).
 *
 * Ordem aqui NÃO determina ordem no preset — o preset.columns escolhe.
 */
import { FULL_TAG_ATTENTION, FULL_TAG_BLING_SHORT, FULL_TAG_SUGGEST, FULL_TAG_URGENT, FULL_TAGS } from './fullShipment';

export const COL_DEFS = {
    select: { label: '', name: '', w: '40px', align: 'center', mono: false },
    thumb: { label: 'Foto', name: 'Foto (thumbnail do anúncio)', w: '48px', align: 'center', mono: false },
    sku: { label: 'SKU', name: 'SKU', w: '118px', align: 'left', mono: true },
    name: { label: 'Produto', name: 'Produto (cadastro)', w: '1.8fr', align: 'left', mono: false },
    mlbTitle: {
        label: 'Anúncio',
        name: 'Título do anúncio ML',
        w: '1.6fr',
        align: 'left',
        mono: false,
    },
    brand: { label: 'Marca', name: 'Marca', w: '90px', align: 'left', mono: false },
    supplier: { label: 'Fornecedor', name: 'Fornecedor', w: '110px', align: 'left', mono: true },
    mlb: { label: 'MLB', name: 'MLB', w: '100px', align: 'left', mono: true },
    inventoryId: { label: 'Inventory', name: 'Inventory ID (Full)', w: '100px', align: 'left', mono: true },
    tags: { label: 'Tags', name: 'Tags', w: '260px', align: 'left', mono: false },
    bling: { label: 'Bling', name: 'Bling', w: '74px', align: 'right', mono: true },
    mlAvail: { label: 'ML disp.', name: 'Mercado Livre disponível', w: '78px', align: 'right', mono: true },
    mlUnavail: { label: 'ML n/disp.', name: 'Mercado Livre não disponível', w: '84px', align: 'right', mono: true },
    mlTotal: { label: 'ML total', name: 'Mercado Livre total', w: '78px', align: 'right', mono: true },
    stockTotal: { label: 'Total', name: 'Estoque total', w: '70px', align: 'right', mono: true },
    sales_today: { label: 'Hoje', name: 'Vendas hoje', w: '60px', align: 'right', mono: true },
    sales_yday: { label: 'Ontem', name: 'Vendas ontem', w: '62px', align: 'right', mono: true },
    sales_d2: { label: '−2d', name: 'Vendas 2 dias atrás', w: '60px', align: 'right', mono: true },
    sales_d3: { label: '−3d', name: 'Vendas 3 dias atrás', w: '60px', align: 'right', mono: true },
    sales_d4: { label: '−4d', name: 'Vendas 4 dias atrás', w: '60px', align: 'right', mono: true },
    sales3: { label: 'Últ. 3d', name: 'Últimos 3 dias', w: '66px', align: 'right', mono: true },
    sales5: { label: 'Últ. 5d', name: 'Últimos 5 dias', w: '66px', align: 'right', mono: true },
    sales7: { label: 'Últ. 7d', name: 'Últimos 7 dias', w: '66px', align: 'right', mono: true },
    sales30: { label: '30d', name: 'Últimos 30 dias', w: '58px', align: 'right', mono: true },
    sales60: { label: '60d', name: 'Últimos 60 dias', w: '58px', align: 'right', mono: true },
    sales90: { label: '90d', name: 'Últimos 90 dias', w: '58px', align: 'right', mono: true },
    sales180: { label: '6m', name: 'Últimos 6 meses', w: '58px', align: 'right', mono: true },
    sales365: { label: '12m', name: 'Últimos 12 meses', w: '60px', align: 'right', mono: true },
    avgPeriod: { label: 'Média/dia', name: 'Média por dia (período ativo)', w: '82px', align: 'right', mono: true },
    periodTotal: { label: 'Total per.', name: 'Unidades vendidas no período ativo', w: '78px', align: 'right', mono: true },
    week1: { label: 'Últ. 7d', name: 'Semana 1 (últimos 7 dias)', w: '70px', align: 'right', mono: true },
    week2: { label: '8-14d', name: 'Semana 2 (8-14 dias atrás)', w: '68px', align: 'right', mono: true },
    week3: { label: '15-21d', name: 'Semana 3 (15-21 dias atrás)', w: '70px', align: 'right', mono: true },
    week4: { label: '22-28d', name: 'Semana 4 (22-28 dias atrás)', w: '70px', align: 'right', mono: true },
    month1: { label: 'Últ. 30d', name: 'Mês 1 (últimos 30 dias)', w: '76px', align: 'right', mono: true },
    month2: { label: '31-60d', name: 'Mês 2 (31-60 dias atrás)', w: '72px', align: 'right', mono: true },
    month3: { label: '61-90d', name: 'Mês 3 (61-90 dias atrás)', w: '72px', align: 'right', mono: true },
    trend: { label: 'Tend.', name: 'Tendência (sparkline)', w: '80px', align: 'left', mono: false },
    coverage: { label: 'Cobert.', name: 'Cobertura de estoque (dias)', w: '76px', align: 'right', mono: true },
    // Envio Full — regras em constants/fullShipment.js.
    fullCoverage: { label: 'Cob. Full', name: 'Cobertura Full em dias (ML total / média)', w: '76px', align: 'right', mono: true },
    fullNeed: { label: 'Nec. Full', name: 'Necessidade de envio ao Full (un.)', w: '76px', align: 'right', mono: true },
    fullSuggest: { label: 'Envio Full', name: 'Sugestão de envio ao Full (limitada ao Bling)', w: '80px', align: 'right', mono: true },
    fullAnalysis: { label: 'Análise Full', name: 'Análise Full (tags do envio)', w: '220px', align: 'left', mono: false },
    bestDay: { label: 'Melhor dia', name: 'Melhor dia (período ativo)', w: '110px', align: 'right', mono: true },
    price: { label: 'Preço', name: 'Preço de venda', w: '80px', align: 'right', mono: true },
    cost: { label: 'Custo', name: 'Preço de custo', w: '80px', align: 'right', mono: true },
    margin: { label: 'Margem', name: 'Margem %', w: '70px', align: 'right', mono: true },
    // Comparativos temporais — derivam de janelas existentes.
    weekGrowth: {
        label: 'Cresc. Sem.',
        name: 'Crescimento semanal (últ. 7d vs 8-14d) %',
        w: '88px',
        align: 'right',
        mono: true,
    },
    monthVariation: {
        label: 'Var. Mens.',
        name: 'Variação mensal (últ. 30d vs 31-60d) %',
        w: '86px',
        align: 'right',
        mono: true,
    },
    periodSplit: {
        label: 'Split',
        name: 'Split do período (1ª metade vs 2ª metade) %',
        w: '78px',
        align: 'right',
        mono: true,
    },
    // Pedidos / status
    orderCount: {
        label: 'Pedidos',
        name: 'Total de pedidos no período',
        w: '70px',
        align: 'right',
        mono: true,
    },
    paidCount: {
        label: 'Pagos',
        name: 'Pedidos pagos/confirmados no período',
        w: '60px',
        align: 'right',
        mono: true,
    },
    cancelledCount: {
        label: 'Cancel.',
        name: 'Pedidos cancelados/inválidos no período',
        w: '68px',
        align: 'right',
        mono: true,
    },
    cancelPercent: {
        label: '% Cancel.',
        name: 'Percentual de cancelamento no período',
        w: '80px',
        align: 'right',
        mono: true,
    },
};

/** Colunas que o preset pode incluir (select é sempre prepended). */
export const SELECTABLE_COLS = [
    'thumb', 'sku', 'name', 'mlbTitle', 'brand', 'mlb', 'inventoryId', 'tags',
    'bling', 'mlAvail', 'mlUnavail', 'mlTotal', 'stockTotal',
    'sales_today', 'sales_yday', 'sales_d2', 'sales_d3', 'sales_d4',
    'sales3', 'sales5', 'sales7', 'sales30', 'sales60', 'sales90', 'sales180', 'sales365',
    'avgPeriod', 'periodTotal', 'bestDay',
    'week1', 'week2', 'week3', 'week4',
    'month1', 'month2', 'month3',
    'trend', 'weekGrowth', 'monthVariation', 'periodSplit',
    'orderCount', 'paidCount', 'cancelledCount', 'cancelPercent',
    'coverage', 'fullCoverage', 'fullNeed', 'fullSuggest', 'fullAnalysis', 'price', 'cost', 'margin',
];

/** Colunas que aceitam visualização em sparkline (linha) ou barra. */
export const CHARTABLE_COLS = new Set([
    'sales3', 'sales5', 'sales7', 'sales30', 'sales60', 'sales90', 'sales180', 'sales365',
    'week1', 'week2', 'week3', 'week4',
    'month1', 'month2', 'month3',
]);

/** Colunas numéricas (todas) — usado pra toggles de visualização e export. */
export const NUMERIC_COLS = new Set([
    'bling', 'mlAvail', 'mlUnavail', 'mlTotal', 'stockTotal',
    'sales_today', 'sales_yday', 'sales_d2', 'sales_d3', 'sales_d4',
    'sales3', 'sales5', 'sales7', 'sales30', 'sales60', 'sales90', 'sales180', 'sales365',
    'avgPeriod', 'periodTotal', 'bestDay',
    'week1', 'week2', 'week3', 'week4',
    'month1', 'month2', 'month3',
    'weekGrowth', 'monthVariation', 'periodSplit',
    'orderCount', 'paidCount', 'cancelledCount', 'cancelPercent',
    'coverage', 'fullCoverage', 'fullNeed', 'fullSuggest', 'price', 'cost', 'margin',
]);

/**
 * True quando uma coluna (built-in) requer formato `custom:` ou é numérica.
 * Usado por toggles de visualização (text/bar/line).
 *
 * @param {string} col
 * @param {{format?: string}|null} customDef
 */
export function IsNumericColumn(col, customDef = null) {
    if (typeof col === 'string' && col.startsWith('custom:')) {
        if (!customDef) return false;
        const fmt = customDef.format || 'number';
        return fmt === 'number' || fmt === 'percentage' || fmt === 'currency';
    }
    return NUMERIC_COLS.has(col);
}

/**
 * True quando a coluna deve renderizar como "—" porque o período filtrado é
 * menor que o mínimo necessário (ex: sales30 com filtro de 7d).
 *
 * @param {string} col
 * @param {number|null|undefined} periodDays
 */
export function IsColumnMasked(col, periodDays) {
    if (periodDays === null || periodDays === undefined) return false;
    const min = COLUMN_MIN_PERIOD_DAYS[col];
    if (!min) return false;
    return Number(periodDays) < min;
}

/**
 * Mínimo de dias do período para que a coluna seja "confiável" no display.
 * Se o usuário filtrar 7 dias, qualquer coluna com requisito > 7 vira "—".
 */
export const COLUMN_MIN_PERIOD_DAYS = {
    sales_today: 1,
    sales_yday: 2,
    sales_d2: 3,
    sales_d3: 4,
    sales_d4: 5,
    sales3: 3,
    sales5: 5,
    sales7: 7,
    trend: 7,
    avg7: 7,
    best7: 7,
    coverage: 7,
    fullCoverage: 7,
    fullNeed: 7,
    fullSuggest: 7,
    fullAnalysis: 7,
    daily: 7,
    week1: 7,
    week2: 14,
    week3: 21,
    week4: 28,
    avgPeriod: 1,
    sales30: 30,
    daily30: 30,
    month1: 30,
    month2: 60,
    month3: 90,
    sales60: 60,
    sales90: 90,
    sales180: 180,
    sales365: 365,
    // Comparativos — requerem a janela do periodo "passado" disponível.
    weekGrowth: 14,
    monthVariation: 60,
    // Split do período é sempre válido (até 1 dia já dá pra fatiar metade).
    periodSplit: 2,
};

/**
 * Offsets relativos (em dias) que cada coluna agregada representa.
 * Usado pelo tooltip do header (`DD/MM à DD/MM`).
 * Convenção: [from, to] em dias atrás (0=hoje, negativos=passado).
 */
export const COL_DATE_OFFSETS = {
    sales_today: [0, 0],
    sales_yday: [-1, -1],
    sales_d2: [-2, -2],
    sales_d3: [-3, -3],
    sales_d4: [-4, -4],
    sales3: [-2, 0],
    sales5: [-4, 0],
    sales7: [-6, 0],
    sales30: [-29, 0],
    sales60: [-59, 0],
    sales90: [-89, 0],
    sales180: [-179, 0],
    sales365: [-364, 0],
    week1: [-6, 0],
    week2: [-13, -7],
    week3: [-20, -14],
    week4: [-27, -21],
    month1: [-29, 0],
    month2: [-59, -30],
    month3: [-89, -60],
};

/** Tags que o backend computa automaticamente — não removíveis manualmente. */
export const SYSTEM_TAGS = new Set([
    'sem estoque',
    'baixo estoque',
    'sem venda 30d',
    'outbound',
    'reputacao warning',
    'reputacao_warning',
    'reputacao unhealthy',
    'reputacao_unhealthy',
    // Envio Full — calculadas no Selector e exibidas na coluna "Análise Full"
    // (row.fullTags), não em row.tags; ver constants/fullShipment.js.
    ...FULL_TAGS,
]);

export function IsSystemTag(tag) {
    return SYSTEM_TAGS.has(String(tag || '').toLowerCase());
}

/**
 * Variante de cor do TBadge por system tag. Cada uma é DISTINTA (sem colisão).
 *   - sem estoque         → danger     (vermelho)
 *   - baixo estoque       → orange     (laranja)
 *   - sem venda 30d       → muted      (cinza)
 *   - outbound            → info       (ciano)
 *   - reputacao warning   → purple     (roxo claro)
 *   - reputacao unhealthy → purpleDeep (roxo intenso)
 *   - full urgente        → danger     (vermelho — crítico, igual sem estoque)
 *   - full atencao        → warn       (amarelo)
 *   - full sugestao       → ok         (verde — ação positiva: dá pra enviar)
 *   - bling insuficiente  → rose       (rosa)
 */
export function GetTagBadgeColor(tag) {
    if (!tag) return 'accent';
    const t = String(tag).toLowerCase();
    if (t === 'sem estoque') return 'danger';
    if (t === 'baixo estoque') return 'orange';
    if (t === 'sem venda 30d') return 'muted';
    if (t === 'outbound') return 'info';
    if (t === 'reputacao warning' || t === 'reputacao_warning') return 'purple';
    if (t === 'reputacao unhealthy' || t === 'reputacao_unhealthy') return 'purpleDeep';
    if (t === FULL_TAG_URGENT) return 'danger';
    if (t === FULL_TAG_ATTENTION) return 'warn';
    if (t === FULL_TAG_SUGGEST) return 'ok';
    if (t === FULL_TAG_BLING_SHORT) return 'rose';
    return 'accent';
}
